export enum RollNoSortOption {
  FEMALE_STUDENTS_FIRST = 'femaleStudentsFirst'
}
export const SCHOOLS_FOR_ROLL_NO_GENERATION = ['BPIS'];
